export default __webpack_public_path__ + "static/media/img1.0ea7eca8.webp";